import React, { useState, useEffect } from 'react';
import { IosShareIcon, XCircleIcon, ArrowSloganIcon } from './Icons';

const InstallPwaPrompt: React.FC = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Detect iOS and Safari, and not in standalone mode
    const isIos = () => /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isSafari = () => !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    const isInStandaloneMode = () => ('standalone' in window.navigator && (window.navigator.standalone as boolean)) || window.matchMedia('(display-mode: standalone)').matches;

    // Check if the prompt has been dismissed before
    const hasDismissedPrompt = localStorage.getItem('pwaInstallPromptDismissed');

    if (isIos() && isSafari() && !isInStandaloneMode() && !hasDismissedPrompt) {
      // Delay prompt to not be too intrusive
      const timer = setTimeout(() => {
        setShowPrompt(true);
      }, 5000); // Show after 5 seconds
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('pwaInstallPromptDismissed', 'true');
    setShowPrompt(false);
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <div 
      role="dialog" 
      aria-modal="true"
      aria-labelledby="pwa-install-title" 
      className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[100] p-4 animate-slide-up-fade-in no-print"
    >
      <div className="bg-slate-800 rounded-lg shadow-2xl w-full max-w-md border border-slate-700 relative text-center p-8">
        <button 
          onClick={handleDismiss} 
          className="absolute top-4 right-4 p-1 text-slate-500 hover:text-white transition-colors rounded-full"
          aria-label="Dismiss install prompt"
        >
          <XCircleIcon className="w-8 h-8"/>
        </button>
        
        <ArrowSloganIcon className="w-16 h-16 mx-auto mb-4" />
        
        <h3 id="pwa-install-title" className="font-bold text-2xl text-white">Get the Full App Experience</h3>
        <p className="text-slate-300 mt-2 mb-6">
          Install JT-Crew Movement on your Home Screen for offline access, real-time notifications, and a faster, full-screen interface.
        </p>
        
        <div className="bg-slate-700 p-4 rounded-lg text-left">
          <p className="font-semibold text-white">Follow these 2 simple steps:</p>
          <ol className="list-decimal list-inside mt-2 text-slate-300 space-y-2">
            <li>Tap the <IosShareIcon className="w-5 h-5 inline-block mx-1" /> icon in your browser's toolbar.</li>
            <li>Scroll down and tap <strong className="text-white">'Add to Home Screen'</strong>.</li>
          </ol>
        </div>

        <button 
          onClick={handleDismiss} 
          className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg"
        >
          Got It
        </button>
      </div>
    </div>
  );
};

export default InstallPwaPrompt;